const moment = require('moment');

window.loadDateTimeDev = moment().format('YYYYMMDDHHmmss');
window.loadDateTimeProd = moment().format('YYYYMMDDHHmm');

import('./bootstrap');

export {};
